<template>
  <section class="clipFolder">
    <clip-filter
      ref="clipFilter"
      :options="{
        hideSearch: true,
        hideCreate: true,
        hideMove: true,
        hideDelete: false,
        hideDownload: true,
      }"
      :total="clipTags.length"
      :selected-clips="selectedTagList"
      @onDelete="dialogDeleteOpen = true"
      @clipToolsOpenChange="toolsOpen = $event"
    >
      <template #start>
        <v-btn
          x-small
          class="clipFolder-create"
          :class="{
            ['clipFolder-create-disabled']: toolsOpen,
          }"
          :color="'text'"
          @click="$emit('onCreate')"
        >
          <span class="icon icon-folder" />
          <div class="'clipFolder-create_text">フォルダ作成</div>
        </v-btn>
      </template>
    </clip-filter>
    <section class="clipFolder-header">
      <app-check
        v-if="toolsOpen"
        v-model="allSelected"
        class="clipFolder-select"
        @input="handleSelectAll"
      />
      <span class="clipFolder-icon"></span>
      <span>名前</span>
    </section>
    <section v-if="loading" class="clipFolder-loading">
      <clip-folder-skeleton v-for="i in 6" :key="i" />
    </section>
    <section
      v-else
      :style="{ height: height ? height - 70 + 'px' : 'auto' }"
      class="clipFolder-body"
    >
      <section
        v-for="(tag, i) in clipTags"
        :key="i"
        class="clipFolder-row"
        :class="{ 'clipFolder-row--selected': !!selectedTags[tag.id] }"
        @click="handleRow(tag)"
      >
        <app-check
          v-if="toolsOpen"
          class="clipFolder-select"
          :value="!!selectedTags[tag.id]"
          @input="handleRow(tag)"
        />
        <span class="clipFolder-icon"
          ><img src="@/assets/img/icon_folder.svg"
        /></span>
        <span class="text-break--custom">{{ tag.name }}</span>
      </section>
    </section>
    <!-- Delete dialog -->
    <clip-dialog-a
      :open="dialogDeleteOpen"
      title="削除"
      @onClose="closeDialogDelete"
    >
      <div class="clip_dialog-content">
        {{ selectedTagList.length }}件のフォルダを<br />
        完全に削除してもよろしいですか？
      </div>
      <template #actions>
        <v-btn
          class="clip_dialog-btn clip_dialog-cancel"
          color="text"
          @click="closeDialogDelete"
        >
          キャンセル
        </v-btn>
        <v-spacer />
        <v-btn
          class="clip_dialog-btn clip_dialog-delete"
          color="text"
          :loading="deleteLoading"
          @click="handleDeleteOk"
        >
          削除する
        </v-btn>
      </template>
    </clip-dialog-a>
    <!-- ----------------- -->
  </section>
</template>

<script>
import ClipFolderSkeleton from '@/components/skeletons/ClipFolderSkeleton.vue';
import ClipFilter from './ClipFilter.vue';
import { mapActions, mapState } from 'vuex';
import ClipDialogA from '../../components/dialogs/ClipDialogA.vue';
export default {
  name: 'ClipFolder',
  components: { ClipFolderSkeleton, ClipFilter, ClipDialogA },
  props: {
    height: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      selectedTagList: [],
      toolsOpen: false,
      dialogDeleteOpen: false,
      deleteLoading: false,
      selectedCams: {},
      allSelected: false,
    };
  },
  computed: {
    ...mapState({
      clipTags: (state) => state.video.clipTags,
    }),
    selectedTags() {
      let tags = {};
      this.selectedTagList.forEach((tag) => {
        tags = { ...tags, [tag.id]: tag };
      });
      return tags;
    },
  },
  watch: {
    dialogDeleteOpen(val) {
      val || this.closeDialogDelete();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('video', ['fetchClipTags', 'deleteTag']),
    async init() {
      try {
        this.loading = true;
        await this.fetchClipTags();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleSelectAll(selected) {
      this.selectedTagList = [];
      if (selected) {
        this.clipTags.forEach((tag) => {
          this.selectedTagList.push(tag);
        });
      }
    },
    closeDialogDelete() {
      this.dialogDeleteOpen = false;
    },
    async handleDeleteOk() {
      try {
        this.deleteLoading = true;
        await this.deleteTag({
          ids: this.selectedTagList.map((clip) => clip.id),
        });
        this.selectedTagList = [];
        this.closeDialogDelete();
        this.dialogMessageText = 'データを削除しました';
      } catch (error) {
        console.error(error);
      } finally {
        this.deleteLoading = false;
      }
    },
    handleRow(tag) {
      if (this.toolsOpen) {
        if (this.selectedTags[tag.id]) {
          const tagIndex = this.selectedTagList.findIndex(
            (item) => item.id === tag.id
          );
          this.selectedTagList.splice(tagIndex, 1);
        } else {
          this.selectedTagList.push(tag);
        }
        this.checkAllSelected();
      } else {
        this.routerReplace({ query: { tab: 0, tag: tag.id } });
      }
    },
    checkAllSelected() {
      this.allSelected = this.selectedTagList.length === this.clipTags.length;
    },
  },
};
</script>

<style lang="scss">
.clipFolder {
  &-create {
    &.v-btn:not(.v-btn--round).v-size--x-small {
      border-radius: 5px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
      background-color: #fff;
      font-size: 10px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.6;
      letter-spacing: normal;
      text-align: left;
      color: #0075c2;
    }
    &-disabled {
      &.v-btn:not(.v-btn--round).v-size--x-small {
        background-color: #eee;
        color: #ccc;
        box-shadow: none;
        cursor: initial;
        pointer-events: none;
      }
    }
    .icon.icon-folder {
      margin-right: 5px;
      font-size: 16px;
    }
  }
  &-select {
    &.customCheck {
      width: 50px;
      height: 0px;
      display: inline-flex;
      justify-content: center;
      vertical-align: sub;

      .customCheck_label {
        display: none;
      }
    }
  }
  &-tools {
    display: flex;
    justify-content: space-between;
  }
  &-header,
  &-row {
    border-bottom: solid 1px #cccccc;
    cursor: pointer;

    &--selected {
      background: #f3f3f3;
    }
    & span {
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #4b4b4b;
      display: inline-block;
      &:last-child {
        width: 85%;
        padding-left: 25px;
      }
    }
  }
  &-icon {
    width: 60px;
    text-align: center;
  }
  &-header {
    font-size: 12px;
    padding: 15px 0;
    vertical-align: sub;
  }
  &-row {
    font-size: 14px;
    padding: 15px 0;
    &:hover {
      background: #eeeeee;
    }
  }
  &-body {
    overflow-y: auto;
  }
}
</style>
